import { API_URL, RECO_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';
const reco = RECO_URL + '/v1';

/**
 * Category Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */

export const categoryService = (http, cookies) => ({
  /**
   * Get All Categories Items
   */
  async getAllCategories() {
    const { data } = await http.$get(`${base}/categories`);
    return { data };
  },

  /**
   * Get Category Feed Articles
   * @param {string} categoryId tag id
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getCategoryFeed(categoryId, page = 1, limit = 20) {
    const useHasNextPage = true;
    const queryParams = encodeQuery({ categoryId, page, limit, author: true, categories: true, breadcrumb: true, useHasNextPage });
    const { data, pagination } = await http.$get(`${base}/articles${queryParams}`);
    return { data, pagination };
  },

  /**
   * Get Video Category Feed Articles
   * @param {string} categoryId tag id
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getVideoCategoryFeed(categoryId, page = 1, limit = 20) {
    const useHasNextPage = true;
    const queryParams = encodeQuery({
      categoryId,
      page,
      limit,
      useHasNextPage,
      categories: true,
      getVideoEntry: true,
    });
    const { data, pagination } = await http.$get(`${base}/videos${queryParams}`);
    return { data, pagination };
  },

  /**
   * Get Category Info From Id
   * @param {string} categoryId category id
   */
  async getCategoryInfoById(categoryId, withSubs = false) {
    const { data } = await http.$get(`${base}/categories/${categoryId}?withSubs=${withSubs}`);
    return { data };
  },

  /**
   * Get Category Popular Feed Articles
   * @param {string} categoryId category id
   */
  async getCategoryPopularFeed(categoryId, limit = 5) {
    const sort = 'agingPopular';
    const useHasNextPage = true;
    const queryParams = encodeQuery({ categoryId, page: 1, limit, sort, useHasNextPage, author: true, categories: true, breadcrumb: true });
    const { data } = await http.$get(`${base}/articles${queryParams}`);
    return { data };
  },

  /**
   * Get Gallery Feed Articles
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getGalleryFeed(page = 1, limit = 26) {
    const useHasNextPage = true;
    const queryParams = encodeQuery({ page, limit, useHasNextPage });
    const { data, pagination } = await http.$get(`${base}/galleries${queryParams}`);
    return { data, pagination };
  },

  /**
   * Get Gallery Popular Feed Articles
   */
  async getGalleryPopularFeed() {
    // TODO: Old API waiting for an update
    // https://api-development.onedio.com/v3/1/1/1/categories/530bd809764e7634c69c39c9/feed?sort=popular&duration=1month
    // const queryParams =  encodeQuery({ sort: 'popular', duration: '1month' } );
    // const { data } = await http.$get(`${base}/categories/${type}/feed${queryParams}`);
    // return { data };

    // Temporary data for popular feed
    const sort = 'agingPopular';
    const useHasNextPage = true;
    const queryParams = encodeQuery({ page: 1, limit: 10, sort, useHasNextPage });
    const { data } = await http.$get(`${base}/galleries${queryParams}`);
    return { data };
  },

  /**
   * Get Random Tag Article Items
   * @param {string} categoryId tag id
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getCategoryRandomFeed(categoryId, page = 1, limit = 10) {
    const sort = 'random';
    const queryParams = encodeQuery({ categoryId, limit, page, sort });
    const { data } = await http.$get(`${base}/articles${queryParams}`);
    return { data };
  },

  /**
   * Get Recommended Articles for User
   * @param {object} params object
   * @param {string} [params.userId]
   * @param {string} [params.categories]
   * @param {string} [params.scopeId]
   * @param {string} [params.placementId]
   * @param {string} [params.page]
   * @param {string} [params.limit]
   *
   */
  async getRecommendedArticles({ userId, categories, scopeId = 1, placementId, page = 1, limit = 9 }) {
    const organization = 'onedio';
    const product = 'onedio';
    const version = '1.0.0';
    const queryParams = encodeQuery({
      placementId,
      userId,
      scopeId,
      organization,
      product,
      version,
      categories,
      page,
      limit,
      additionalFields: 'description,author',
    });
    const { data, pagination } = await http.$get(`${reco}/recommendations${queryParams}`);
    return { data, pagination };
  },

  /**
   * Get Recommended Api Status
   */
  async getRecommendedApiStatus() {
    const { data: result } = await http.$get(`${reco}/status`);
    return result;
  },
});
